import { render, staticRenderFns } from "./transport-info-card.vue?vue&type=template&id=76a69870&scoped=true"
import script from "./transport-info-card.vue?vue&type=script&lang=js"
export * from "./transport-info-card.vue?vue&type=script&lang=js"
import style0 from "./transport-info-card.vue?vue&type=style&index=0&id=76a69870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a69870",
  null
  
)

export default component.exports